<template>
  <div id="init-home-container" class="mt-3 d-flex" style="width: 100%">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <auth></auth>

    <v-spacer></v-spacer>
    <v-main>
      <v-container
        class="whitesmoke black--text"
        id="home-container"
        style="max-width: 1280px"
      >
        <deny_email
          v-if="show_deny_email"
          @closediag="closediag"
          :request="request"
        ></deny_email>
        <!-- Barb expansion panel -->
        <div class="barb-exp-panel d-flex flex-column align-center">
          <v-expansion-panels v-model="recent_panel">
            <v-expansion-panel>
              <v-expansion-panel-header>
                Recent Requests
              </v-expansion-panel-header>
              <v-expansion-panel-content class="content-wrap whitesmoke">
                <v-list dense>
                  <v-list-item-group
                    v-model="request_selected"
                    class="whitesmoke"
                  >
                    <v-list-item
                      two-line
                      v-for="reqx in lst_recent"
                      :key="reqx.requestId"
                      @change="request_selected_change"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ reqx.req_date }}</v-list-item-title
                        >
                        <v-list-item-subtitle
                          >{{ reqx.casenum }} | {{ reqx.lname }},
                          {{ reqx.fname }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <!-- <div class="d-flex flex-column justify-start">
                  
                  <div
                    class="d-flex flex-row justify-start flex-wrap"
                    v-for="reqx in lst_recent"
                    :key="reqx.requestId"
                  >
                    <button block class="req_btns">
                      {{ reqx.req_date }} {{ reqx.casenum }} {{ reqx.lname }},{{
                        reqx.fname
                      }}
                    </button>
                  </div>
                </div> -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <v-card class="white">
          <div class="d-flex flex-row justify-start align-center">
            <v-combobox
              ref="myComboBox"
              class="ml-2"
              style="max-width: 320px; position: relative; top: 14px"
              v-model="search"
              :items="lst_recent_casenums"
              label="Case# or Name"
              outlined
              dense
            ></v-combobox>
            <v-btn id="find" class="accent ml-2 mr-2" @click="find">Find</v-btn>
            <v-spacer class="flex-grow-1"></v-spacer>
            <v-btn class="accent ml-2 mr-2" @click="go_csv">CSV</v-btn>
          </div>
          <div
            class="d-flex flex-column justify-start align-start"
            v-if="lstResults.length > 0"
          >
            <h4 class="ml-3">Choose a Request</h4>
            <div
              v-for="req in lstResults"
              :key="req.requestId"
              class="d-flex flex-row justify-start align-start ml-5 mt-3 pb-4"
              style="font-size: 1.3rem; font-weight: 600"
            >
              <v-btn class="accent x-small" @click="view_request(req.requestId)"
                >View</v-btn
              >
              <div class="ml-2">{{ req.lname }}, {{ req.fname }}</div>
              <div class="ml-2">{{ req.casenum }}</div>
              <div class="ml-2">{{ req.s_CreateDate }}</div>
            </div>
          </div>
        </v-card>
        <v-card class="mt-4">
          <template>
            <v-tabs
              v-if="show"
              centered
              v-model="tab"
              background-color="transparent"
              color="accent"
            >
              <v-tab v-for="tabitem in tabitems" :key="tabitem">
                {{ tabitem }}
              </v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="tabitem in tabitems" :key="tabitem">
              <v-card flat>
                <div id="case_content" v-if="tab == 0 && show">
                  <div
                    class="d-flex flex-row justify-start align-center flex-wrap"
                  >
                    <v-select
                      class="ml-2 mobile-btn mt-2"
                      style="max-width: 320px; position: relative; top: 14px"
                      :items="status_items"
                      label="Status"
                      outlined
                      v-model="sel_status"
                      @change="status_changed"
                    ></v-select>
                    <v-spacer class="flex-grow-1"></v-spacer>

                    <!-- <v-btn class="accent ml-2 mr-2 mt-2 mobile-btn"
                        >Release</v-btn
                      >
                      <v-btn class="accent ml-2 mr-2 mt-2 mobile-btn"
                        >Destory</v-btn
                      > -->
                    <v-btn
                      class="accent ml-2 mr-2 mt-2 mobile-btn"
                      @click="denymail"
                      >Deny Email</v-btn
                    >

                    <!-- <v-spacer class="flex-grow-1"></v-spacer> -->
                    <v-btn
                      class="accent ml-2 mr-2 mt-2 mobile-btn"
                      @click="print"
                      >Print</v-btn
                    >
                  </div>
                  <v-card elevation="3" class="pa-3 ml-2 mr-2 mb-3">
                    <div
                      id="case_data"
                      class="d-flex flex-row justify-start align-center flex-wrap mt-4"
                    >
                      <!-- row -->
                      <div class="label-pairs">
                        <label>RPD Case #:</label>
                        <article>{{ casedata.casenum }}</article>
                      </div>
                      <div class="label-pairs">
                        <label>Request Date:</label>
                        <article>{{ casedata.req_date }}</article>
                      </div>
                      <div class="label-pairs">
                        <label>Status:</label>
                        <article>{{ casedata.status }}</article>
                      </div>
                    </div>
                    <div
                      class="d-flex flex-row justify-start align-center flex-wrap mt-4"
                    >
                      <!-- row -->
                      <div class="label-pairs">
                        <label>Requestor Name:</label>
                        <article>
                          {{ casedata.lname }}, {{ casedata.fname }}
                        </article>
                      </div>
                      <div class="label-pairs">
                        <label>Date of Birth:</label>
                        <article>
                          {{ casedata.dob }}
                        </article>
                      </div>
                      <div class="label-pairs">
                        <label>SSN:</label>
                        <article>
                          {{ casedata.ssn }}
                        </article>
                      </div>
                    </div>
                    <div
                      class="d-flex flex-row justify-start align-center flex-wrap mt-4"
                    >
                      <!-- row -->
                      <div class="label-pairs">
                        <label>Phone #:</label>
                        <article>{{ casedata.ph_number }},</article>
                      </div>
                      <div class="label-pairs">
                        <label>Email:</label>
                        <article>
                          {{ casedata.email }}
                        </article>
                      </div>
                    </div>
                  </v-card>

                  <!-- Barb expansion panel -->
                  <div class="barb-exp-panel d-flex flex-column align-center">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Requestor Details
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="content-wrap">
                          <div
                            class="requestor d-flex flex-column justify-center"
                          >
                            <requestor
                              :form_request="request"
                              :req_file_docs="req_file_docs"
                              :req_file_pers="req_file_pers"
                              :req_file_rpd_docs="req_file_rpd_docs"
                              :questions="questions"
                            ></requestor>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>

                  <!-- End Barb expansion panel -->
                </div>
                <div v-if="tab == 1">
                  <h1 class="ml-2">To Be Decided</h1>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .v-item--active {
    background-color: darkgray;
    font-weight: 800;
    color: white;
  }
  /*Barb fixes*/
  .barb-exp-panel {
    width: 98%;
    margin: 0 auto;
  }

  .content-wrap :deep .v-expansion-panel-content__wrap {
    padding: 0 12px !important;
  }

  .requestor {
    width: 98%;
  }

  .label-pairs {
    display: flex; /* or inline-flex */
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: baseline;
    margin-left: 12px;
  }
  .label-pairs label {
    font-weight: 600;
  }
  .label-pairs article {
    font-size: 1.1rem;
    padding-left: 3px;
  }
  #home-container {
    width: 100vw;
    max-width: 100vw;
    height: auto;
  }
  .first-btn-bar {
    width: 100%;
  }
  .mobile-btn {
    width: 96%;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

//  768 media q
@media (min-width: 768px) {
  .mobile-btn {
    width: auto;
  }
  .first-btn-bar {
    width: 50%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import auth from "./auth.vue";
const requestor = () => import("./requestor.vue");
const deny_email = () => import("./deny_email.vue");

//const add_edit = () => import("./add_edit.vue");

export default {
  name: "Home",
  components: { requestor, deny_email, auth },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      recent_panel: -1,
      request_selected: -1,
      show_deny_email: false,
      lst_recent: [],
      lst_recent_casenums: [],
      requestId: null,
      lstResults: [],
      req_file_docs: [],
      req_file_pers: [],
      req_file_rpd_docs: [],
      questions: null,
      request: {},
      new_casedata: {
        casenum: "",
        req_date: "",
        lname: "",
        fname: "",
        dob: "",
        ssn: "",
        ph_number: "",
        email: "",
      },
      casedata: {
        casenum: "",
        req_date: "",
        lname: "",
        fname: "",
        dob: "",
        ssn: "",
        ph_number: "",
        email: "",
      },
      status_items: ["Received", "Released", "Destroyed", "Denied"],
      show: false,
      search: "",
      items: ["24-123456", "23-123456", "21-123456", "20-123456"],
      tabitems: ["CASE", "TBD"],
      tab: null,
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
  },
  computed: {},
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    request_selected_change() {
      this.$nextTick(() => {
        //  alert(this.request_selected);
        this.recent_panel = -1;
        this.requestId = this.lst_recent[this.request_selected].requestId;
        this.search = this.lst_recent[this.request_selected].casenum;
        this.get_request();
      });
    },
    closediag() {
      this.show_deny_email = false;
    },
    denymail() {
      this.show_deny_email = true;
    },
    status_changed() {
      let formIn = {};
      formIn.requestId = this.requestId;
      formIn.sel_status = this.sel_status;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "status_changed";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.request = self.mno(data);
          this.swall_it("Save Status", "Saved.", "success", null, null);
        })
        .catch((msg) => {
          this.swall_it("Please Report this error.", msg, "error", null, null);
        });
    },
    // Approved
    // Denied
    // Destroyed
    // Other Agency/ Wrong Agency Closed
    // Pending
    // Received
    // Released
    // User Deleted
    //"Received","Released", "Destroyed"
    req_status() {
      if (
        this.request.status == "Pending" ||
        this.request.status == "Received"
      ) {
        this.sel_status = "Received";
        return true;
      }
      if (
        this.request.status == "Approved" ||
        this.request.status == "Released"
      ) {
        this.sel_status = "Released";
        return true;
      }
      if (
        this.request.status == "Denied" ||
        this.request.status == "Destroyed"
      ) {
        this.sel_status = "Destroyed";
        return true;
      }
      this.sel_status = "Other";
    },
    go_csv() {
      window.open("/csv", "_blank");
    },
    clear_request() {
      this.show = false;
      this.results = [];
      this.request = {};
      this.casedata = this.mno(this.new_casedata);
      this.requestId = null;
    },
    view_request(requestId) {
      this.mrbreakpoint("clear");
      this.requestId = requestId;
      this.get_request();
      this.lstResults = [];
    },
    get_request() {
      this.show_loader(true);
      var formIn = {};
      formIn.requestId = this.requestId;
      formIn.apiname = "get_request";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.get_req_file_docs(self.requestId);
          self.get_req_file_pers(self.requestId);
          self.get_req_file_rpd_docs(self.requestId);
          self.get_questions(self.requestId);
          data.dob = self.format_date_us(data.dob);
          data.req_date = self.format_date_us(data.req_date);
          self.request = self.mno(data);
          self.casedata = self.mno(data);
          this.req_status();
          self.show = true;
          self.show_loader(false);
        })
        .catch((msg) => {
          this.swall_it("Please Report this error.", msg, "error", null, null);
        });
    },
    get_req_file_docs(id) {
      this.show_loader(true);
      var formIn = {};
      formIn.requestId = id;
      formIn.apiname = "get_req_file_docs";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.req_file_docs = self.mno(data);
        })
        .catch((msg) => {
          this.swall_it("Please Report this error.", msg, "error", null, null);
        });
    },
    get_req_file_pers(id) {
      this.show_loader(true);
      var formIn = {};
      formIn.requestId = id;
      formIn.apiname = "get_req_file_pers";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.req_file_pers = self.mno(data);
        })
        .catch((msg) => {
          this.swall_it("Please Report this error.", msg, "error", null, null);
        });
    },
    get_req_file_rpd_docs(id) {
      this.show_loader(true);
      var formIn = {};
      formIn.requestId = id;
      formIn.apiname = "get_req_file_rpd_docs";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.req_file_rpd_docs = self.mno(data);
        })
        .catch((msg) => {
          this.swall_it("Please Report this error.", msg, "error", null, null);
        });
    },
    get_questions(id) {
      this.show_loader(true);
      var formIn = {};
      formIn.requestId = id;
      formIn.apiname = "get_questions";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.questions = self.mno(data);
        })
        .catch((msg) => {
          this.swall_it("Please Report this error.", msg, "error", null, null);
        });
    },
    print() {
      window.open("/print?id=" + this.requestId, "_blank");
    },
    find() {
      let self = this;
      this.$refs.myComboBox.blur();
      document.getElementById("find").focus();
      this.$nextTick(() => {
        if (this.search == "") {
          this.swall_it(
            "Find Status",
            "Search term in combobox empty",
            "warning",
            null,
            null
          );
          return true;
        }
        this.show_loader(true);
        var formIn = {};
        console.log("search: " + this.search);
        formIn.term = this.search;
        formIn.apiname = "findcase";

        this.$store
          .dispatch("anyapi", formIn)
          .then((data) => {
            self.show_loader(false);
            self.mrbreakpoint("finding");
            if (data.length == 0) {
              this.swall_it(
                "Find Status",
                "Case # or Name Not found.  Please try other search terms.",
                "warning",
                null,
                null
              );
              self.clear_request();
            }
            if (data.length == 1) {
              //go get it
              self.requestId = data[0].requestId;
              self.get_request();
            }
            if (data.length > 1) {
              //display list in results
              self.clear_request();
              self.lstResults = self.mno(data);
              for (let index = 0; index < self.lstResults.length; index++) {
                const req = self.lstResults[index];
                req.s_CreateDate = self.format_date_us(req.s_CreateDate);
              }
            }
          })
          .catch((msg) => {
            this.swall_it(
              "Please Report this error.",
              msg,
              "error",
              null,
              null
            );
          });
        //
      });
    },
    init() {
      this.show_loader(true);
      var formIn = {};

      formIn.apiname = "get_recent";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_recent = self.mno(data);
          for (let index = 0; index < self.lst_recent.length; index++) {
            const element = self.lst_recent[index];
            element.req_date = self.format_date_us(element.req_date);
            self.lst_recent_casenums.push(element.casenum);
          }
        })
        .catch((msg) => {
          this.swall_it("Please Report this error.", msg, "error", null, null);
        });
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
